import { useSelector } from 'react-redux';

import { getSelectedGroup } from '../../../../../../selectors';

export const useGroupData = () => useSelector(getSelectedGroup);
